import { Theme } from '@mui/material/styles'

import pageBackgroundImage from '../../images/dashboard-background.png'

const BANNER_HEIGHT = '178px'

const useStyles = {
  mainContainer: {
    marginTop: 'calc(100px - 24px)',
  },
  banner: (theme: Theme) => ({
    height: BANNER_HEIGHT,
    paddingTop: theme.spacing(3),
  }),
  bannerImage: (theme: Theme) =>
    ({
      position: 'absolute',
      zIndex: -1,
      left: 0,
      top: theme.mixins.toolbar.minHeight,
      width: '100%',
      height: BANNER_HEIGHT,
      opacity: 0.5,
      background: `url(${pageBackgroundImage}), rgba(224, 232, 245, 0.1)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    }) as const,
  informationSideBar: (theme: Theme) => ({
    width: '100%',
    maxWidth: '310px',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    borderRadius: '12px',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  }),
  avatar: (theme: Theme) => ({
    height: '80px',
    width: '80px',
    backgroundColor: theme.palette.primary.shades['4p'],
    color: theme.palette.primary.dark,
  }),
  iconTextBox: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 0),
  }),
  auditText: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center',
    lineHeight: '166%',
    margin: theme.spacing(2, 0),
  }),
  tabs: {
    minHeight: '42px',
    marginBottom: '16px',
  },
  tabButtonBaseRoot: {
    minHeight: 0,
    padding: '9px 16px 9px 10px',
  },
  subsectionContainer: {
    padding: '28px 0 0 0',
  },
  gridTabsWrapper: (theme: Theme) => ({
    marginTop: '102px',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(),
    },
  }),
  subsection: (theme: Theme) => ({
    marginBottom: theme.spacing(2),
  }),
  notificationPreference: {
    textAlign: 'center',
  },
  notificationPreferenceOnIcon: (theme: Theme) => ({
    color: theme.palette.success.light,
  }),
  notificationPreferenceOffIcon: (theme: Theme) => ({
    color: theme.palette.error.light,
  }),
  contactInfoContainer: {
    width: '100%',
  },
  linkOnHoverContainer: {
    width: 'calc(100% - 32px)',
  },
  linkOnHover: (theme: Theme) => ({
    color: theme.palette.text.primary,
    textDecoration: 'none',
    flex: 1,
    '&:hover, &:focus': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  }),
  truncatedText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  copyIconButton: (theme: Theme) => ({
    padding: 0,
    marginLeft: theme.spacing(1),
    width: '24px',
    height: '24px',
    color: theme.palette.primary.main,
  }),
  copyIcon: {
    fontSize: '16px',
  },
  userIdContainer: {
    position: 'relative',
    width: '100%',
  },
  copyIdIconButton: (theme: Theme) => ({
    width: '24px',
    height: '24px',
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '-1px',
  }),
  emailSubheader: {
    width: '100%',
    textAlign: 'center',
  },
  formButtonContainer: (theme: Theme) => ({
    marginTop: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
  }),
  formikDropdownContainer: (theme: Theme) => ({
    marginTop: theme.spacing(-2),
    width: '100%',
    maxWidth: '303px',
  }),
  dialogText: (theme: Theme) => ({
    marginBottom: theme.spacing(2),
  }),
  dialogButtons: (theme: Theme) => ({
    marginTop: theme.spacing(3),
    '&:nth-of-type(1)': {
      marginRight: theme.spacing(2),
    },
  }),
  passwordErrorAlert: (theme: Theme) => ({
    marginBottom: theme.spacing(2),
  }),
  rightSpaceButton: (theme: Theme) => ({
    marginRight: theme.spacing(2),
  }),
  subscriptionViewSection: {
    maxHeight: '670px',
    overflowY: 'auto',
    padding: '28px 0 0 0',
  },
  bottomButtonsContainer: (theme: Theme) => ({
    padding: theme.spacing(2, 1, 1, 1),
  }),
}
export default useStyles
